import { Route, HashRouter, Routes } from "react-router-dom";
import ControleComissoes from "../views/page_controle_comissoes";
import HistoricoVendas from "../views/page_historico_vendas";
import PageLogin from "../views/page_login";
import axios from "axios";
import AuthenticationService from "./AuthenticationService";
import AdministrarUsuarios from "../views/page_administrar_usuarios";
import AlterarSenha from "../views/page_alterar_senha";

const getBlockedApiHosts = () => {
  return (process.env.REACT_APP_BLOCKED_HOSTS || "app.kgmlan.com.br")
    .split(",")
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean);
};

const isProductionApiAllowed = () => {
  return process.env.REACT_APP_ALLOW_PRODUCTION_API === "true";
};

const isBlockedApiRequest = (request) => {
  if (!request?.url || isProductionApiAllowed()) {
    return false;
  }

  const blockedHosts = getBlockedApiHosts();

  try {
    const targetUrl = new URL(request.url, window.location.origin);
    return blockedHosts.includes(targetUrl.hostname.toLowerCase());
  } catch (error) {
    return blockedHosts.some((host) => request.url.toLowerCase().includes(host));
  }
};

axios.interceptors.request.use(request => {
  if (isBlockedApiRequest(request)) {
    return Promise.reject(new Error(`Chamada bloqueada para ambiente de produção: ${request.url}`));
  }

  if (AuthenticationService.isUserLoggedIn()){
    const token = AuthenticationService.getToken()
    request.headers.Authorization =  'Bearer ' + token;
  }
  return request;
});
axios.interceptors.response.use(response => {
  return response
}, (error) => {
  if(error.response){
      if(error.response.status === 401 && AuthenticationService.isUserLoggedIn()){
        console.log('sem auth')
        AuthenticationService.removerTokens()
        AuthenticationService.logout()
        window.location = "/"
      } else {
        return Promise.reject(error)
      }
  }
})

export default function Rotas(){
  return(
    <HashRouter>
      <Routes>
        <Route path="/" element={<PageLogin/>} ></Route>
        <Route path="/gestao-comissoes" element={<ControleComissoes/>} ></Route>
        <Route path="/consulta-vendas-agenciadas" element={<HistoricoVendas/>} ></Route>
        <Route path="/administrar-usuarios" element={<AdministrarUsuarios/>} ></Route>
        <Route path="/alterar-senha" element={<AlterarSenha/>} ></Route>
      </Routes>
    </HashRouter>
  )
}
